import { purposeLabel } from "../data/assignments";
import { CheckIcon } from "./Icons";
import ui from "./ui.module.css";

// The gateway derives each learner's state; these are only its words.
export const STATE = {
  not_started: "Not started",
  working: "Working",
  completed: "Completed",
  reviewed: "Reviewed",
};
export const STATE_ORDER = ["not_started", "working", "completed", "reviewed"];

export const StatePill = ({ state }) => (
  <span className={`${ui.pill} ${ui[`pill_${state}`] || ""}`}>
    {STATE[state] || STATE.not_started}
    {state === "reviewed" && <CheckIcon size={14} />}
  </span>
);

export const stepsText = ({ completedSteps = 0, totalSteps = 0 }) =>
  totalSteps > 0
    ? `${completedSteps} of ${totalSteps} step${totalSteps === 1 ? "" : "s"}`
    : "No work yet";

// "3 of 5 steps" and a bar; never the learner's answer.
export const StepProgress = ({ completedSteps = 0, totalSteps = 0 }) => {
  const text = stepsText({ completedSteps, totalSteps });
  return (
    <span className={ui.stepProgress}>
      <span className={ui.stepCount}>{text}</span>
      <progress
        className={ui.progress}
        value={totalSteps > 0 ? completedSteps : 0}
        max={totalSteps > 0 ? totalSteps : 1}
        aria-label={text}
      />
    </span>
  );
};

const sameDay = (a, b) => a.toDateString() === b.toDateString();

export const formatWhen = (iso, now = new Date()) => {
  if (!iso) return null;
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return null;
  const time = date.toLocaleTimeString(undefined, { hour: "2-digit", minute: "2-digit" });
  if (sameDay(date, now)) return `Today, ${time}`;
  const day = date.toLocaleDateString(undefined, { day: "numeric", month: "short" });
  return `${day}, ${time}`;
};

// "Healthy Habits · Week 7" for a piece of work's lesson, or "Homework" for
// work set outside a lesson.
export const lessonText = ({ lessonTitle, week, assignmentPurpose }) =>
  assignmentPurpose
    ? purposeLabel(assignmentPurpose)
    : [lessonTitle, week != null && `Week ${week}`].filter(Boolean).join(" · ");

// Scores come back as fixed-point text ("3.00"); teachers typed "3".
export const scoreText = (value) =>
  value == null || value === "" ? "" : String(Number(value));

// The teacher's judgement on one piece of work, in a line.
export const ReviewSummary = ({ review }) => {
  if (!review) return null;
  const score =
    review.score != null &&
    `${scoreText(review.score)}${review.max_score != null ? ` / ${scoreText(review.max_score)}` : ""}`;
  const parts = [review.judgement, score].filter(Boolean).join(" · ");
  return (
    <div className={ui.reviewSummary}>
      <p className={ui.meta}>
        {review.status === "completed"
          ? `Reviewed${review.reviewed_at ? ` ${formatWhen(review.reviewed_at)}` : ""}`
          : "Review started, not finished"}
      </p>
      {parts && <p>{parts}</p>}
      {review.comment && <p className={ui.preserveLines}>{review.comment}</p>}
    </div>
  );
};
